<template lang="pug">
    .game-content.game-content_static
        games-wrapper(
            :type='type'
            :exerciseId='exerciseId'
            :homework-id='homeworkId'
            :play-again='playAgain'
        )
</template>

<script>
    import PlayBox from './PlayBox.vue';
    import { mapState } from 'vuex';
    import GamesWrapper from '../../../trainer/games/GamesWrapper';

    export default {
        props: ['type', 'exerciseId', 'homeworkId'],
        data() {
            return {
                playAgain: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
        },
        components: {
            PlayBox,
            GamesWrapper,
        },
        beforeRouteLeave(to, from, next) {
            if (this.$store.state.trainer.game) {
                if (!(to.meta.type && to.meta.type === 'trainer')) {
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        },
    };
</script>

<style lang="scss" scoped>
    @import '@/assets/sass/games/main.scss';
</style>
